import { useState } from 'react';
import closeIcon from '@packages/shared/assets/cross.svg';
import Image from '@packages/shared/core/common/components/common/Image';
import Button from '@packages/shared/core/common/components/common/Button';
import Modal from '@packages/shared/core/common/components/common/Modal';
import TextField from '@packages/shared/core/common/components/common/TextField';
import styles from './TopicToDiscussModalScreen.module.scss';

type TopicToDiscussModalScreenProps = {
  open: boolean;
  onClose: () => void;
  title: string;
  button: string;
  onSendCustomAnswer: (value: string) => void;
};

export const TopicToDiscussModalScreen = ({
  open,
  onClose,
  title,
  button,
  onSendCustomAnswer,
}: TopicToDiscussModalScreenProps) => {
  const [value, setValue] = useState('');

  const onSubmit = () => {
    onSendCustomAnswer(value);
  };

  return (
    <Modal disableBackdropClick open={open} onClose={onClose}>
      <div className={styles.wrapper}>
        <Image
          className={styles.close}
          type="future"
          src={closeIcon}
          alt="close"
          width={16}
          height={16}
          onClick={onClose}
        />

        <h3 className={styles.title}>{title}</h3>

        <TextField
          className={styles.input}
          placeholder="Type what’s on your mind..."
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />

        <Button disabled={!value} wrapperClassName={styles.buttonWrapper} onClick={onSubmit} className={styles.button}>
          {button}
        </Button>
      </div>
    </Modal>
  );
};

export default TopicToDiscussModalScreen;
